import { createFileRoute } from '@tanstack/react-router'

import { listEvalExpressionsOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { ValidationRulesPage } from '@/pages/taxonomy/ValidationRules.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/',
)({
  component: ValidationRulesPage,
  loader: ({ context: { queryClient }, params: { spaceId } }) => {
    queryClient.ensureQueryData(
      listEvalExpressionsOptions({
        path: {
          spaceID: spaceId,
        },
      }),
    )
  },
})
